export default "__VITE_ASSET__DccN_Bqt__"